module.exports = __webpack_public_path__ + "arrow-to-previous.svg?454cbfa468c9c0fe77594ba549d4423a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-to-previous.svg
// module id = 34
// module chunks = 0